import { Tabs } from "antd";
import styles from "./callTransferTab.module.scss";
import TabAgentTransfer from "./tabAgentTransfer";
import TabQueueTransfer from "./tabQueueTransfer";
import TabTransfer from "./tabTransfer";
import { CallService } from "../../../../services/call_service";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { CallServices } from "../../../../base/service/apiServices";
import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import TabTransferCallFLow from "./tabTransferCallFlow";
import { useSelector } from "react-redux";
import { ChatState } from "../../../../base/models/model";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";

function CallTransferTab() {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { incomingCallDetail } = popUpDetails;
  const { dialPadChanges } = CallService(dispatch, navigate);
  const openDialPadInCall = () => {
    dialPadChanges(false, false, false, false, false, false);
  };

  const getCallConfigDetails = () => {
    CallServices.get(`/callflowlist`).then((resp: any) => {
      dispatch(CallPopUpAgentActions.callList(resp.data.result))
    });
  }
  const currentSession: ChatState = useSelector((state: any) => state.chatReducer.currentSession);
  useEffect(() => {
    getCallConfigDetails()
  }, [])
  const loginPlanDetail = GetItemFromStorage(LocalStorage.PLAN_ID);

  return (
    <>{
      currentSession?.ChatHistoryId != null &&

      <div className={`${styles.callcontainartopsec} ${styles.overallcalltransfermod}`}>
        <div className={styles.closeTransfer}>
          <span className={styles.transTitle}>Agent Transfer</span>
          <span
            className="icon__IconCloseNew16"
            onClick={openDialPadInCall}
          ></span>
        </div>
        <Tabs defaultActiveKey="1" className={`queueTab transferTab  calltransfertabbmodd`}>
          <Tabs.TabPane
            tab={<span className="icon__AgentTransfer20"></span>}
            key="1"
          >
            <TabAgentTransfer />
          </Tabs.TabPane>
          {/* {(loginPlanDetail === 33 ||
            loginPlanDetail === 55 ||
            loginPlanDetail === 56 ||
            loginPlanDetail === 57 ||
            loginPlanDetail === 141 ||
            loginPlanDetail === 32 ||
            loginPlanDetail === 42) &&
            <Tabs.TabPane
              tab={<span className="icon__QueuTransfer20"></span>}
              key="2"
            >
              <TabQueueTransfer />
            </Tabs.TabPane>
          } */}
        </Tabs>
      </div>}
      {currentSession?.channeltype === "Call" && <>
        <div className={`${styles.callcontainartopsec} ${styles.overallcalltransfermod}`}>
          <div className={styles.closeTransfer}>
            <span className={styles.transTitle}>Agent Transfer</span>
            <span
              className="icon__IconCloseNew16"
              onClick={openDialPadInCall}
            ></span>
          </div>
          <Tabs defaultActiveKey="1" className={`queueTab transferTab  calltransfertabbmodd calltransferingtab`}>
            {!incomingCallDetail?.isConference && <>
              <Tabs.TabPane
                tab={<span className="icon__AgentTransfer20"></span>}
                key="1"
              >
                <TabAgentTransfer />
              </Tabs.TabPane>
            </>}

            {!incomingCallDetail?.isConference && <>
              <Tabs.TabPane
                tab={<span className="icon__QueuTransfer20"></span>}
                key="2"
              >
                <TabQueueTransfer />
              </Tabs.TabPane>
            </>}
            {((!incomingCallDetail?.isConference) || (currentSession?.IsInBound === 0 && popUpDetails?.transfer_type != "AGENT")) && <>

              <Tabs.TabPane
                className={`${styles.tabcontentnone} dialpadtab`}
                tab={<span className="icon__CallTransfer20"></span>}
                key="3"
              >

                <div className="headerdialpadcontainer insidetabcontainer">
                  <div className="headerdialpad">
                    <TabTransfer />
                  </div>
                </div>
              </Tabs.TabPane>          </>}
            {!incomingCallDetail?.isConference && <>

              <Tabs.TabPane
                tab={<span className="icon__TransferMonitor20"></span>}
                key="4"
              >
                <TabTransferCallFLow />
              </Tabs.TabPane>
            </>}
          </Tabs>
        </div></>}
    </>
  );
}
export default CallTransferTab;
